var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 846.66 846.66",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sensors") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M312.3 213.23l0 26.16 -71.25 0 0 30.98 71.25 0 0 35.59 -39.85 0 0 30.98 39.85 0 0 35.58 -71.25 0 0 30.98 71.25 0 0 35.58 -39.85 0 0 30.98 39.85 0 0 35.59 -71.25 0 0 30.98 71.25 0 0 50.24c37.05,19.13 62.38,57.78 62.38,102.35 0,63.59 -51.55,115.13 -115.13,115.13 -63.58,0 -115.12,-51.54 -115.12,-115.13 0,-44.57 25.33,-83.22 62.37,-102.35l0 -373.64c0,-69.78 105.5,-69.78 105.5,0zm223.15 -67.9l61.06 35.25 0 28.51 30.37 0 34.51 -49.82 26.19 18.09 -21.97 31.73 36.63 0 0 31.93 -36.64 0 21.98 31.73 -26.19 18.09 -34.51 -49.82 -30.37 0 0 28.51 -61.06 35.25 0 27.67 49.82 34.51 -18.09 26.19 -31.73 -21.98 0 36.64 -31.93 0 0 -36.63 -31.73 21.97 -18.09 -26.19 49.82 -34.51 0 -27.67 -61.06 -35.25 0 -28.51 -30.38 0 -34.5 49.82 -26.19 -18.09 21.97 -31.73 -36.63 0 0 -31.93 36.63 0 -21.97 -31.73 26.19 -18.09 34.5 49.82 30.38 0 0 -28.51 61.06 -35.25 0 -27.68 -49.82 -34.5 18.09 -26.19 31.73 21.97 0 -36.63 31.93 0 0 36.63 31.73 -21.97 18.09 26.19 -49.82 34.5 0 27.68zm-14.58 22.97l48.46 27.97 0 57.57 -48.45 27.97 -2.79 0 -48.46 -27.97 0 -57.57 48.47 -27.97 2.77 0zm67.99 -35.21l46.85 -46.84 22.57 22.58 -46.83 46.84 -22.59 -22.58zm-161.34 22.58l-46.84 -46.84 22.58 -22.58 46.84 46.84 -22.58 22.58zm22.58 161.35l-46.84 46.83 -22.58 -22.57 46.84 -46.85 22.58 22.59zm161.35 -22.59l46.83 46.85 -22.57 22.57 -46.85 -46.83 22.59 -22.59zm-91.97 -108.31l33.72 19.47 0 38.93 -33.72 19.46 -33.71 -19.46 0 -38.93 33.71 -19.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensors);
export default __webpack_public_path__ + "static/media/sensors.d12f5ca7f7d87d456660884c5a6f83b2.svg";
export { ForwardRef as ReactComponent };